"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-4 justify-center">
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted-light/30 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap">
        {menuItems.map(item => <NavigationMenuItem key={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="relative text-sm font-medium text-foreground-dark transition-all duration-[var(--duration-medium)] after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full focus:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark border-t border-border-strong py-8 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col items-center gap-6">
          {}
          

          <Separator className="w-full max-w-2xl bg-border" />

          {}
          <MenuProvider menu_id="5" className="footer-navigation">
            <FooterMenuConsumer />
          </MenuProvider>

          <Separator className="w-full max-w-2xl bg-border" />

          {}
          <p className="text-sm text-muted">© 2020&nbsp;Freedom Productions, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}